import { create } from "framework/http/endpoint";
import { createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { createEntityRequest } from "framework/http/rest/jsonRequest";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var AthletesApiUri = ApiUriPrefix + "athletes";
function apiAthleteIdentification(entity) {
    var uri = AthletesApiUri + "/identify";
    var transport = intoTransportAthleteIdentification(entity);
    var request = createEntityRequest(transport);
    return create(uri, request, createEntityResponseFactory(fromTransportAthleteIdentification));
}
function fromTransportAthleteIdentification(entity) {
    //  entity.birthDate1 = fromApiTransportDate(entity.birthDate1);
    //  entity.birthDate2 = fromApiTransportDate(entity.birthDate2);
    return entity;
}
function intoTransportAthleteIdentification(entity) {
    var result = JSON.parse(JSON.stringify(entity));
    // result.birthDate1 = intoApiTransportDate(entity.birthDate1);
    // result.birthDate2 = intoApiTransportDate(entity.birthDate2);
    return result;
}
export { apiAthleteIdentification, };
